/* eslint-disable no-magic-numbers */

import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import type { GetInvoiceReportsResponseAPI } from '@omnipresentgroup/types';
import { HttpResponse, http } from 'msw';

import { API_PATH } from './constants';
import {
  DEFAULT_INVOICE,
  DEFAULT_INVOICE_REPORT_EMPLOYEES_RESPONSE,
  DEFAULT_INVOICE_REPORTS_RESPONSE,
  INVOICE_REPORT_EMPLOYEE_BREAKDOWN_WITH_COMPARISON,
  INVOICE_REPORT_EMPLOYEE_BREAKDOWNS,
} from './fixtures';

export const invoiceReportsHandlers = [
  http.get('*/invoices/kolleno?companyId=*', () =>
    HttpResponse.json(
      {
        url: 'URL_TEST',
      },
      {
        status: HTTPStatusCodes.OK,
      },
    ),
  ),
  http.get(
    `*/${API_PATH}/:companyId/invoices/:invoiceId/employees/:employeeId/breakdown?compareWith=*`,
    ({ params, request }) => {
      const url = new URL(request.url);
      const response = url.searchParams.get('compareWith')
        ? INVOICE_REPORT_EMPLOYEE_BREAKDOWN_WITH_COMPARISON
        : INVOICE_REPORT_EMPLOYEE_BREAKDOWNS.find(
            (ib) => ib.id === params.employeeId,
          );
      return HttpResponse.json(response, {
        status: HTTPStatusCodes.OK,
      });
    },
  ),
  http.get(
    `*/${API_PATH}/:companyId/invoices/:invoiceId/employees/:employeeId`,
    ({ params }) =>
      HttpResponse.json(
        DEFAULT_INVOICE_REPORT_EMPLOYEES_RESPONSE.data.find(
          (employee) => employee.id === params.employeeId,
        ),
        {
          status: HTTPStatusCodes.OK,
        },
      ),
  ),
  http.get(`*/${API_PATH}/:companyId/invoices/:invoiceId/employees`, () =>
    HttpResponse.json(DEFAULT_INVOICE_REPORT_EMPLOYEES_RESPONSE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.post(`*/${API_PATH}/:companyId/invoices/:invoiceId/approve`, () =>
    HttpResponse.json(
      {},
      {
        status: HTTPStatusCodes.OK,
      },
    ),
  ),
  http.get(`*/${API_PATH}/:companyId/invoices/:invoiceId/download`, () =>
    HttpResponse.text('', {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(`*/${API_PATH}/:companyId/invoices/:invoiceId`, () =>
    HttpResponse.json(DEFAULT_INVOICE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get<never, never, GetInvoiceReportsResponseAPI>(
    `*${API_PATH}/:companyId?*`,
    () => {
      return HttpResponse.json(DEFAULT_INVOICE_REPORTS_RESPONSE, {
        status: HTTPStatusCodes.OK,
      });
    },
  ),
  http.post(`*/${API_PATH}/:companyId/invoices/:invoiceId/force-sync`, () =>
    HttpResponse.json(
      {},
      {
        status: HTTPStatusCodes.OK,
      },
    ),
  ),
];
